import { Component } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  standalone: true,
    selector: 'app-page-not-found',
    imports: [],
    templateUrl: './page-not-found.component.html',
    styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {
  constructor(private router: Router) {
    setTimeout(() => this.router.navigate(['/']), 5000); 
  }
  goHome() {
    this.router.navigate(['/'])
  }
}
